import Button from 'assets/components/button/Button';
import ThemeButtonMenuItem from 'assets/components/button/themes/Theme.Button.MenuItem';
import FilterForm from 'assets/components/filters/filterForm/FilterForm';
import ThemeFilterFormDrawer from 'assets/components/filters/filterForm/themes/Theme.FilterForm.Drawer';
import Icon from 'assets/components/icon/Icon';
import { getLocales } from 'assets/locales/Locale';
import DropdownButton from 'assets/templates/dropdownButton/DropdownButton';
import ThemeDropdownButtonPopup from 'assets/templates/dropdownButton/themes/Theme.DropdownButton.Popup';
import { OrderType } from 'config/Api.Config';
import { useInsurerProvider } from '../Insurer.Hooks';

export default function InsurerFilters() {
  const { lang } = getLocales();
  const { listApi } = useInsurerProvider();

  return (
    <FilterForm
      subcomponents={ThemeFilterFormDrawer}
      search={listApi.body?.search}
      onSearch={(search) => listApi.execute((body) => ({ ...body, search }))}
      filters={listApi?.body}
      onFilter={(newFilers) => listApi?.execute(newFilers)}
      onReset={listApi?.reset}
      headerActions={
        <DropdownButton
          buttonMedia={<Icon class="fas-sort" />}
          horizontalPosition="auto_fixed"
          verticalPosition="auto_fixed"
          htmlElementProps={{ title: lang.sort }}
          subcomponents={ThemeDropdownButtonPopup}
          dropdownOptions={
            <>
              <Button
                class={ThemeButtonMenuItem}
                render={lang.newerFirst}
                media={<Icon class="fas-caret-up" />}
                onClick={listApi.execute}
                data={(currentFilters) => ({
                  ...currentFilters,
                  orderBy: undefined,
                  orderType: undefined,
                })}
              />
              <Button
                class={ThemeButtonMenuItem}
                render={lang.olderFirst}
                media={<Icon class="fas-caret-up" />}
                onClick={listApi.execute}
                data={(currentFilters) => ({
                  ...currentFilters,
                  orderBy: 'id',
                  orderType: OrderType.asc,
                })}
              />
              <Button
                class={ThemeButtonMenuItem}
                render={lang.ascendingByName}
                media={<Icon class="fas-caret-up" />}
                onClick={listApi.execute}
                data={(currentFilters) => ({
                  ...currentFilters,
                  orderBy: 'Name',
                  orderType: OrderType.asc,
                  thenType: [OrderType.asc, OrderType.asc, OrderType.asc],
                })}
              />
              <Button
                class={ThemeButtonMenuItem}
                render={lang.descendingByName}
                media={<Icon class="fas-caret-down" />}
                onClick={listApi.execute}
                data={(currentFilters) => ({
                  ...currentFilters,
                  orderBy: 'Name',
                  orderType: OrderType.desc,
                  thenType: [OrderType.desc, OrderType.desc, OrderType.desc],
                })}
              />
            </>
          }
        />
      }
    />
  );
}
